import StartupsFundraisesInstance from 'modules/startupsFundraises/repository';

export function getFundraises(opts) {
  return StartupsFundraisesInstance.getFundraises(opts);
}
